import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        overflowY: 'scroll',
        backgroundColor: '#ffff'
    },
    viewContent: {
        margin: '3% 0'
    },
    viewHeaderTable: {
        border: '1px solid #e6e6e6',
        borderRadius: '14px 14px 0 0',
        padding: '0 30px 0 7px'
    },
    preview: {
        padding: '24px 20%'
    },
    studentName: {
        "& svg": {
          margin: '0 5px',
          color: '#2C75BD'
        }
    },
    section: {
        fontSize: '20px',
        textAlign: 'center',
        fontWeight: 'bold',
        margin: '5% 0 3%'
    },
    title: {
        fontWeight: 'bold',
        marginRight: 5
    },
    chart: {
        marginRight: '-15px'
    },
    chartTitle: {
        fontSize: 14,
        margin: 'auto 0'
    },
    chartSubTitle: {
        fontSize: 10,
        margin: 'auto 0'
    },
    close: {
        marginLeft: 'auto',
        color: '#505D63',
        '& .icon': {
          marginTop: -3,
          marginRight: 3,
          fontSize: '8pt'
        },
      },
      button: {
        textDecoration: 'none',
        display: 'flex',
        padding: '7px 15px 7px 12px',
        borderRadius: 3,
        width: '28%',
        '& >div': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
        '& .label': {
          fontSize: '13pt'
        },
        cursor: 'pointer'
      },
      grid: {
          display: 'flex'
      },
      table: {
          "& thead ": {
            "& tr":{
                backgroundColor: '#ffffff',
                border: '1px solid #E7EBF0'
            }
          }
      },
      tableHeader: {
          backgroundColor: '#E7EBF0',
          borderTop: '1px solid #E7EBF0'
      },
      tableTitle:{
        padding: '4%',
        fontWeight: 'bold',
        margin: 'auto 0'
      },
      tableBody: {
        borderRadius: '14px !important',
        border: '1px solid #E7EBF0',
        "& td": {
            border: 'none'
        }
      },
      tableCell: {
        textAlign: 'center'
      },
      tableCellIndicator: {
        maxWidth: '200px'
      },
      indicatorLabel: {
        height: 'auto',
        lineHeight: '1.5em',
        textAlign: 'start',
        padding: '7px',
        fontSize: '14px',
        minWidth: '180px',
        boxShadow: 'none' 
      },
      expectationLabel: {
        textTransform: 'initial',
        height: 'auto',
        lineHeight: '1.5em',
        textAlign: 'start',
        padding: '7px 26px 7px 6px',
        fontSize: '14px',
        minWidth: '200px',
        boxShadow: 'none' 
      },
      expectationButton: {
        backgroundColor: '#fff',
        borderLeft: '#83f2a1 9px solid',
        borderRadius: '9px',
        height: 'auto',
        maxHeigth: 85,
        display: 'inline'
      },
      legend: {
        fontSize: '.9rem',
        fontWeight: 'normal',
        direction: 'row',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        marginTop: '5%'
      },
      legendBox:{
        display: 'inline-flex',
        textAlign: 'left'
      },
      legendLabel: {
        marginLeft: 9,
        "& > span": {
          fontSize: '.7rem'
        }
      },  
      legendDot: {
        display: 'inline-table',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        width: 15,
        height: 15,
        fontSize: '9pt',
        color: '#fff',
        margin: 5,
        backgroundColor: '#ff3a3a',
        "& > span": {
          marginTop: 1,
          marginLeft: 1
        },
      },    
      statusDot: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        width: 20,
        height: 20,
        fontSize: '9pt',
        color: '#fff',
        backgroundColor: '#ff3a3a',
        "& > span": {
          marginTop: 1,
          marginLeft: 1
        },
        "& > svg": {
          fontSize: '11.5pt'
        },
      },      
      statusWrapper: {
        display: 'inline-flex',
      },
      pendingCell: {
        maxWidth: 5
      },
      readMoreIcon: {
        position: 'absolute',
        fontSize: 23,
        right: 6,
        top: '34%',
        color: '#b4b4b4'
      },
      question: {
        margin: 30
      },
      questionBtn: {
        minWidth: 0,
        width: 45,
        border: 0,
        borderRadius: '100%',
        "&:hover": {
          border: 0
        }
      },
      questionDialog: {
        maxWidth: '60%'
      },
      questionStepper: {
        //padding: '14px 26%'
      },
     '@media (max-width: 800px)': { 
        viewContent: {
          display: 'inline-block'
        },
      },
     '@media (max-width: 480px)': {
        tableTitle:{
          padding: '4% 0 0'
        },    
        preview: {
          padding: 0
        },
        button: {
          padding: 0,
          width: 'auto',
        },
        grid: {
          justifyContent: 'flex-start'
        }
      }
    }))

export {useStyles as default}
